import React from 'react';
import "../../styles/Hero.css";
import heroImage from '../../assets/creator3.webp';

export default function Hero() {
  return (
    <section className="hero">
      <div className="hero-container">

        
        <div className="hero-left">
          <div className="badge">
            ✨ India's Leading Creator Learning Platform
          </div>

          <h1>
            Beyond School.
            <br />
            Build <span>Skills.</span>
          </h1>

          <p>
            Learn Content creation and video editing from Graduate FF & his team, the minds behind 5+ channels, 2B+ views, and 
            <strong> 9M+ subscribers.</strong>
          </p>

          <div className="buttons">
  <button 
    className="primary"
    onClick={() => {
      window.location.hash = '#courses';
      window.scrollTo(0, 0);
    }}
  >
    All Courses →
  </button>
  
  <button className="watch">
    ▶ Watch Video
  </button>
</div>

          <div className="stats">
  
  <div className="stat-item">
    <div className="stat-header-with-badge">
      <h3>4.7K+</h3>
      <div className="stat-avatar-stack">
        <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=100&q=80" alt="Learner 1" />
        <img src="https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=100&q=80" alt="Learner 2" />
        <img src="https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?auto=format&fit=crop&w=100&q=80" alt="Learner 3" />
      </div>
    </div>
    <span>Happy Learners</span>
  </div>

  
  <div className="stat-item">
    <h3>9M+</h3>
    <span>Subscribers</span>
  </div>

  <div className="stat-item">
    <h3>2B+</h3>
    <span>Views Generated</span>
  </div>


  <div className="stat-item">
    <div className="stat-header-with-badge">
      <h3>4.9/5</h3>
      <span className="stat-stars-badge">★★★★★</span>
    </div>
    <span>Average Rating</span>
  </div>
</div>
        </div>

        
        <div className="hero-right">
          {/* Ambient Lighting Backdrop Blobs */}
          <div className="blob blob1"></div>
          <div className="blob blob2"></div>

          
          <div className="card youtube">
            📺 YouTube Growth
          </div>
          <div className="card editing">
            🎬 Video Editing
          </div>
          <div className="card marketing">
            📸 Social Media Marketing
          </div>
          <div className="card certificate">
            🏆 Certificate
          </div>
          <div className="card access">
            ∞ Lifetime Access
          </div>

          <img
            src={heroImage}
            alt="Creator Dost"
            className="creator"
          />
        </div>

      </div>
    </section>
  );
}